import { defineStore, getActivePinia, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { checkResponse, handleException, } from '@/assets/js/src/util/apiTools'
import { useLangStore, } from '@/assets/js/src/modules/lang/_pinia/lang'

const API_HELP = '/api/help'

export const useHelpListStore = defineStore('helpList', {
    state: () => ({
        helpItems: [],
        helpCategories: [],
    }),
    actions: {
        async getHelpItems () {
            let activePinia = getActivePinia()
            let langStore = useLangStore(activePinia)
            try {
                // Api-Request senden
                let useCache = true
                let apiResponse = await fetch({
                    url: `${API_HELP}`,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache,
                    includeTagsInId: true,
                    tags: [
                        'help',
                        `locale.${langStore.locale}`,
                    ],
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                const helpItems = apiResponse.data

                let categories = []

                helpItems.forEach((elem) => {
                    if (typeof elem.categories !== 'undefined') {
                        elem.categories.forEach((category) => {
                            categories.push(category)
                        })
                    }
                })

                let ids = []
                categories = categories.filter((elem) => {
                    if (ids.includes(elem.id)) {
                        return false
                    }
                    ids.push(elem.id)

                    return true
                })

                this.helpCategories = categories
                this.helpItems = helpItems
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true, true)
            }
        },
    },
})
